<template>
  <div>
    <div :style="'margin-left:' + level * 35 + 'px;'">
      <v-row>
        <v-col>
          <workflow-item-type-and-params :params.sync="item.params" :type.sync="item.type" :style="{ 'margin-bottom': item.type === 'start' ? '30px' : 0 }" />
          <v-select
            v-model="contextTrueResult"
            :items="workflowOptions"
            item-text="text"
            item-value="value"
            :label="item.type !== 'start' ? $t('settings.workflow.conditionTrue') : $t('settings.workflow.startAction')"
            style="max-width: 300px; display: inline-block; max-height: 65px;"
            outlined
          />
          <v-icon small v-if="typeof contextTrueResult === 'string'">fa-level-down-alt</v-icon>
          <workflow-item-acceptation-by v-if="contextTrueResult === 'acceptationBySpecifiedUsers'" :level="level + 1" :user-ids="item.conditionalTrueResult" />
          <workflow-item
            v-if="typeof contextTrueResult === 'string' && contextTrueResult !== 'acceptationBySpecifiedUsers'"
            :item.sync="item.conditionalTrueResult"
            :level="level + 1"
          />
          <span v-if="typeof item.conditionalFalseResult !== 'undefined' && item.type !== 'start'">
            <br />
            <v-select
              v-model="contextFalseResult"
              :items="workflowOptions"
              item-text="text"
              item-value="value"
              :label="$t('settings.workflow.conditionFalse')"
              outlined
              style="max-width: 300px; display: inline-block; max-height: 55px;"
            />
            <v-icon small v-if="typeof contextFalseResult === 'string'">fa-level-down-alt</v-icon>
            <workflow-item-acceptation-by
              v-if="contextFalseResult === 'acceptationBySpecifiedUsers'"
              :level="level + 1"
              :user-ids="item.conditionalFalseResult"
            />
            <workflow-item
              v-if="typeof contextFalseResult === 'string' && contextFalseResult !== 'acceptationBySpecifiedUsers'"
              :item.sync="item.conditionalFalseResult"
              :level="level + 1"
            />
          </span>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import WorkflowItemAcceptationBy from "./WorkflowItemAcceptationBy";
import WorkflowItemTypeAndParams from "./WorkflowItemTypeAndParams";
export default {
  name: "WorkflowItem",
  components: { WorkflowItemTypeAndParams, WorkflowItemAcceptationBy },
  props: {
    item: {
      //type: Object,
      required: true
    },
    level: {
      default: 0,
      required: false
    }
  },
  data: () => ({}),
  methods: {
    contextResultGetter(value) {
      if (Array.isArray(value)) {
        return "acceptationBySpecifiedUsers";
      }
      return typeof value === "object" && value !== null ? value.type : value;
    },
    contextResultSetter(val, trueFalse) {
      let contextItem = this.item;
      let item;
      if (typeof val === "string") {
        if (val === "acceptationBySpecifiedUsers") {
          item = [];
        } else {
          item = {
            type: val,
            params: [],
            conditionalTrueResult: false,
            conditionalFalseResult: false
          };
        }
      } else {
        item = val;
      }
      contextItem[trueFalse ? "conditionalTrueResult" : "conditionalFalseResult"] = item;
      this.$emit("update:item", contextItem);
    }
  },
  computed: {
    contextTrueResult: {
      get() {
        return this.contextResultGetter(this.item.conditionalTrueResult);
      },
      set(val) {
        this.contextResultSetter(val, true);
      }
    },
    contextFalseResult: {
      get() {
        return this.contextResultGetter(this.item.conditionalFalseResult);
      },
      set(val) {
        this.contextResultSetter(val, false);
      }
    },
    workflowOptions() {
      return [
        { text: this.$t("settings.workflow.acceptation"), value: true },
        { text: this.$t("settings.workflow.rejection"), value: false },
        { text: this.$t("settings.workflow.standardFlow"), value: null },
        //{ text: this.$t("settings.workflow.customAcceptationUsers"), value: "acceptationBySpecifiedUsers" },
        { text: this.$t("settings.workflow.delegationTask"), value: "delegationTaskEquals" },
        { text: this.$t("settings.workflow.costCentre"), value: "delegationCostCentreEquals" },
        { text: this.$t("settings.workflow.overallCost"), value: "delegationOverallCostAbove" }
      ];
    }
  }
};
</script>

<style scoped />
